import { Pipe, PipeTransform } from '@angular/core';

export interface Person {
    AiLinked?: boolean;
    Name?: string;
    RecordId?: string;
    NameChanged?: boolean;
}

export function isNewPerson(person: Person | undefined): boolean {
    return person?.Name !== undefined && person.RecordId === undefined;
}

export function isUpdatePerson(person: Person | undefined): boolean {
    return person?.NameChanged === true;
}

export function isSetPerson(person: Person | undefined): boolean {
    return person?.RecordId !== undefined;
}

export function isUnsetPerson(person: Person | undefined): boolean {
    return person?.RecordId === undefined && person?.Name === undefined;
}

export function isPerson(person: Person | undefined): boolean {
    return isNewPerson(person) || isUpdatePerson(person) || isSetPerson(person);
}

@Pipe({
    name: 'isPerson'
})
export class IsPersonPipe implements PipeTransform {
    transform<Person>(value: any): value is Person {
        return isPerson(value);
    }
}
